import { useParams, Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/utils-format";

export default function OrderSuccess() {
    const { orderNumber } = useParams();
    return (
        <section className="section">
            <div className="container-x max-w-[640px] text-center">
                <CheckCircle2 size={56} className="text-[#003E4D] mx-auto" />
                <h1 className="font-serif text-[40px] md:text-[52px] mt-6">Order placed!</h1>
                <p className="eyebrow mt-3">Order #{orderNumber}</p>
                <p className="mt-4 text-[16px] text-[#4a5568] leading-relaxed">
                    Thank you. A HearClear audiologist will contact you within 24 hours to verify your
                    audiogram, confirm fitting and finalize delivery / clinic appointment.
                </p>
                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                    <a href={waLink("919971925446", `Hi, I just placed order ${orderNumber}.`)} target="_blank" rel="noreferrer" className="btn-whatsapp" data-testid="success-whatsapp">
                        <MessageCircle size={16} /> Confirm on WhatsApp
                    </a>
                    <Link to="/" className="btn-secondary" data-testid="success-home">
                        Back to home <ArrowRight size={16} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
